import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { observer } from 'mobx-react'

import GeneralFormSection from './01-GeneralFormSection'
import ReferenceFormSection from './02-ReferenceFormSection'
import BookingFormSection from './03-BookingFormSection'
import MaterialFormSection from './04-MaterialFormSection'
import MediaFormSection from './05-MediaFormSection'
import OverviewSection from './06-OverviewSection'
import ValidationError from '../../shared/components/ValidationError'

import fieldSpecs from '../fieldSpecs'

@observer
class Form extends Component {

  static defaultProps = {
    current: {}
  }

  static propTypes = {
    current: PropTypes.object,
    goToSection: PropTypes.func,
    hideValidationErrors: PropTypes.bool,
    onClose: PropTypes.func,
    readOnly: PropTypes.bool,
    steps: PropTypes.array,
    validationObj: PropTypes.object,
  }

  constructor(props: Object) {
    super(props)
    this.state = {
      // eslint-disable-next-line
      formData: {}
    }
  }

  render() {

    const {
      current,
      hideValidationErrors,
      goToSection,
      dirty,
      validationObj,
      readOnly,
      onChange,
      steps,
      section,
    } = this.props

    const sectionProps = {
      ...current,
      validationObj,
      readOnly,
      onChange,
      dirtyFields: dirty,
      goToSection,
      steps,
      fieldSpecs
    }

    return (
      <div className="horizontal">
        <div className="vertical v-scrollable">

          <GeneralFormSection
            show={section === 'general'}
            {...sectionProps}
          />

          <ReferenceFormSection
            show={section === 'reference'}
            {...sectionProps}
          />

          <BookingFormSection
            show={section === 'booking'}
            {...sectionProps}
          />

          <MaterialFormSection
            show={section === 'material'}
            {...sectionProps}
          />

          <MediaFormSection
            show={section === 'media'}
            {...sectionProps}
          />

          <OverviewSection
            show={section === 'overview'}
            {...sectionProps}
          />
        </div>

        <ValidationError
          className="fixed"
          validFields={current.validFields}
          fieldSpecs={fieldSpecs}
          steps={steps}
          goToSection={goToSection}
          readOnly={readOnly || hideValidationErrors}
        />

      </div>
    )
  }
}

export { Form as default }



// WEBPACK FOOTER //
// ./src/program/components/Form.js